module.exports = __webpack_public_path__ + "f664baa937331d405496a1cfe86838b6.jpg";